import Page from "components/base/Page";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import ALCWarehouse from "./alc";
import CharlesKendall from "./charlesKendall";
import ChinsStockPages from "./china";
import ChinaV2Routes from "./chinaV2";
import FSIStockPage from "./fsi";
import { LeftButtons } from "./Header";
import SupplierStocks from "./supplierStocks";

function StockIndex() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="china/*" element={<ChinsStockPages />} />
        <Route path="china-v2/*" element={<ChinaV2Routes />} />
        <Route path="supplier/*" element={<SupplierStocks />} />
        <Route path="alc/*" element={<ALCWarehouse />} />
        <Route path="charles-kendall/*" element={<CharlesKendall />} />
        <Route path="fsi/*" element={<FSIStockPage />} />
        <Route path="*" element={<Navigate to="china" />} />
      </Route>
    </Routes>
  );
}

const Layout = () => (
  <Page className="h-screen" leftButtons={<LeftButtons />}>
    <Outlet />
  </Page>
);

export default StockIndex;
